type Size = 'small' | 'medium' | 'large' | 'xlarge';

const sizes: Size[] = ['small', 'medium', 'large', 'xlarge'];

/**
 * TODO: This should be correctly typed with emotion's CSSInterpolation and Interpolation types.
 *  This will be possible once common-utils is fully converted to TypeScript.
 */
type CSSInterpolationAny = any;

/**
 * Combine appropriate "per breakpoint" styles, cascading responsively upwards.
 */
export default function responsiveStyles(
  size: Size,
  styles: Partial<{ [size in Size]: CSSInterpolationAny }>
): CSSInterpolationAny {
  const relevantStyles = sizes
    .filter(
      currentSize =>
        styles.hasOwnProperty(currentSize) &&
        // Only include styles for equal or greater than breakpoints
        sizes.indexOf(size) >= sizes.indexOf(currentSize)
    )
    .map(currentSize => styles[currentSize]);

  return relevantStyles.length > 0 ? [...relevantStyles, { label: size }] : [];
}

export function responsiveStylesFn(
  styles: Partial<{ [size in Size]: CSSInterpolationAny }>
) {
  return (size: Size) => responsiveStyles(size, styles);
}
